import { List, NeoModel } from "@singularsystems/neo-core";
import { AppService, Types } from '../../../App/Services/AppService';
import { Views } from "@singularsystems/neo-react";
import CheckQueryLookup from "../Models/Lookups/CheckQueryLookup";
import TierDropdownLookup from "../Models/Lookups/TierDropdownLookup";

@NeoModel
export default class ManagerCheckQueryComponentVM extends Views.ViewModelBase{
    
    public showManagedComponent: boolean = false
    public managedCheckQuery = new CheckQueryLookup();
    public tierDropdownList = new List(TierDropdownLookup);

    

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        public checkQueryApi = AppService.get(Types.ApiClients.CheckQueryApiClient),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications)) {
        super(taskRunner);
    }

    
    public async initialise() {
        this.showManagedComponent = true;
        this.tierDropdownList.set(await (await this.checkQueryApi.getTierDropdownList()).data);
    }
}